/* v8 Path G — Shared module-level ledger cache.
   Replaces the legacy `window.__lensLedgerCache` / `globalThis` bridge. Both
   engine.js (consumer) and data-ledger.js (producer) import from here.
   Tiny surface on purpose — keep it a data pipe, not a state manager. */

let _cache = null;
let _source = 'unset';
let _commercialTimingSignals = null;
let _commercialTimingSource = 'unset';

export function setMonthlyLedgerCache(rollups, source = 'manual') {
  _cache = Array.isArray(rollups) ? rollups : null;
  _source = source;
}

export function getMonthlyLedgerCache() {
  return _cache;
}

export function getMonthlyLedgerSource() {
  return _source;
}

export function setLedgerCommercialTimingSignals(signals, source = 'manual') {
  _commercialTimingSignals = Array.isArray(signals) ? signals : null;
  _commercialTimingSource = source;
}

export function getLedgerCommercialTimingSignals() {
  return _commercialTimingSignals;
}

export function getLedgerCommercialTimingSource() {
  return _commercialTimingSource;
}
